import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { useParams } from "react-router-dom"
import { useGetInstence } from "../../../hooks/useGetInstence"
import { useState } from "react";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import ResultHandler from "../../../components/ResultHandler";
import { INFO_FIELDS } from "./CONSTANT";
import { formatCurrency } from "../../../utils/formatCurrency";
import { ZoomImage } from "../../../components/zoom-image/ZoomImage";
import { getHousing } from "../../../api/housing";
import RoomsTable from "./rooms/RoomsTable";

export default function HousingDetails(){
    const {housingId} = useParams()
    const [housing, setHousing] = useState(null)

    const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
        getHousing,
        housingId,
        response => {
            setHousing({
                ...response.data.housing,
            })
        }
    )

    const [housingInfoOpen, setHousingInfoOpen] = useState("open")
    const [housingImgOpen, setHousingImgOpen] = useState("open")
    const [roomsOpen, setRoomsOpen] = useState("open")

    return(
        <div className="page-content company-profile-page">
            <div className="container-fluid">
                <Breadcrumb title="" breadcrumbItem={"Housing Details"} />
                <ResultHandler loading={instenceLoading} />

                <Container fluid>
                    {housing && <>
                        <Row>
                           <Col md={housing.picture ? 6 : 12} lg={housing.picture ? 8 : 12}>
                                <Accordion style={{marginBottom: "20px"}} open={housingInfoOpen} toggle={() => setHousingInfoOpen(i => i ? null : "open" )}>
                                    <AccordionItem>
                                        <AccordionHeader targetId="open">
                                            <h5 className="mb-0 text-uppercase">Housing Info</h5>
                                        </AccordionHeader>
                                        <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                            {INFO_FIELDS.map(f => <Row className="mb-1" key={f.key}>
                                                <Col xs={6}>
                                                    <Label className="mb-0">{f.label}</Label>
                                                </Col>
                                                <Col xs={6}>
                                                    <span style={{fontWeight: "bold"}}>
                                                        {
                                                            f.type === 'price'
                                                            ? formatCurrency(housing[f.key])
                                                            : typeof housing[f.key] === 'boolean'
                                                            ? housing[f.key] ? 'Yes' : 'No'
                                                            : housing[f.key]
                                                        }
                                                    </span>
                                                </Col>
                                            </Row>)}  
                                        </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                            </Col>
                            
                            {housing.picture && (
                                <Col md={6} lg={4}>
                                    <Accordion style={{marginBottom: "20px"}} open={housingImgOpen} toggle={() => setHousingImgOpen(i => i ? null : "open" )}>
                                        <AccordionItem>
                                            <AccordionHeader targetId="open">
                                                <h5 className="mb-0 text-uppercase">Picture</h5>
                                            </AccordionHeader>
                                            <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                                <ZoomImage src={housing.picture} alt="housing image" width="100%"/>
                                            </AccordionBody>
                                        </AccordionItem>
                                    </Accordion>
                                </Col>
                            )}
                        </Row>

                        <Row>
                           <Col md={12}>
                                <Accordion style={{marginBottom: "20px"}} open={roomsOpen} toggle={() => setRoomsOpen(i => i ? null : "open" )}>
                                    <AccordionItem>
                                        <AccordionHeader targetId="open">
                                            <h5 className="mb-0 text-uppercase">Rooms</h5>
                                        </AccordionHeader>
                                        <AccordionBody style={{backgroundColor: "white"}} accordionId="open">
                                            <RoomsTable/>
                                        </AccordionBody>
                                    </AccordionItem>
                                </Accordion>
                            </Col>
                        </Row>
                    </>}
                </Container>
            </div>
            
        </div>
    )
}